import {
  AppContentLayoutNav,
  ContentWidth,
  FooterType,
  HorizontalNavType,
  NavbarType,
} from "@layouts/enums";
import type { LayoutConfig } from "@layouts/types";
import { breakpointsVuetify } from "@vueuse/core";

export const layoutConfig: LayoutConfig = {
  app: {
    title: "All Care\nPet Transport",
    logo: h("img", {
      src: "/images/all-care-pet-logo.png",
      alt: "All Care Pet Transport",
      class: "app-brand-logo",
      width: 36,
      height: 36,
      style:
        "display:block; object-fit:contain; inline-size:36px; block-size:36px",
    }),
    contentWidth: ContentWidth.Boxed,
    contentLayoutNav: AppContentLayoutNav.Vertical,
    overlayNavFromBreakpoint: breakpointsVuetify.md,

    // isRTL: false,
    i18n: {
      enable: true,
    },
    iconRenderer: h("div"),
  },
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: true,
  },
  footer: {
    type: FooterType.Static,
  },
  verticalNav: {
    isVerticalNavCollapsed: false,
    defaultNavItemIconProps: { icon: "ri-circle-line" },
  },
  horizontalNav: {
    type: HorizontalNavType.Sticky,
    transition: "none",
    popoverOffset: 0,
  },
  icons: {
    chevronDown: { icon: "ri-arrow-down-line" },
    chevronRight: { icon: "ri-arrow-right-line" },
    close: { icon: "ri-close-line" },
    verticalNavPinned: { icon: "ri-record-circle-line" },
    verticalNavUnPinned: { icon: "ri-circle-line" },
    sectionTitlePlaceholder: { icon: "ri-subtract-line" },
  },
};
